import {Inject, Injectable} from '@angular/core';
import {IControlloModify, IDatoControllo} from './models/dati-controllo.model';
import { IFileControlli } from './models/file-controlli.model';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPrelievo } from './models/prelievo.model';
import { PRELIEVO_CONTROLLO_SINGOLO_QUERY_SERVICE_INSTANCE,
        PRELIEVO_CONTROLLO_SINGOLO_ENDPOINT} from './prelievo.config';
import { QueryService } from 'src/app/core/services/query.service';
import { ApiService } from 'src/app/core/services/api.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IParametriAlert } from './models/parametri-alert';
import { ParametriObblMancanti } from './models/parametri-obbligatori-mancanti.model';
import { IControlliDettaglio } from './models/prelievo-dettaglio.model';



@Injectable({
  providedIn: 'root'
})
export class ControlloSingoloUpdateService extends CrudService<IControlloModify> {

  constructor(
    @Inject(PRELIEVO_CONTROLLO_SINGOLO_QUERY_SERVICE_INSTANCE) public readonly queryControlloSingolo: QueryService<IControlloModify>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super('web-controlli-update-generico', api, snackbar);
  }

}
